
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/all_ugame",
      function () {
        return require("private-next-pages/all_ugame.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/all_ugame"])
      });
    }
  